module.exports = __webpack_public_path__ + "static/media/Icon awesome-credit-card.a7d9c4e9.svg";